import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { map } from 'rxjs';
import { memo } from '@polkadot/rpc-core';
export function firstObservable(obs) {
  return obs.pipe(map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        a = _ref2[0];

    return a;
  }));
}
export function firstMemo(fn) {
  return function (instanceId, api) {
    return memo(instanceId, function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return firstObservable(fn.apply(void 0, [api].concat(args)));
    });
  };
}